import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Button,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Modal,
  Pagination,
  Radio,
  Row,
  Select,
  Table,
} from "antd";
import { Option } from "antd/es/mentions";
import moment from "moment";

import Swal from "sweetalert2";

import reviewApi from "../../../apis/Review.api";
import { setLoading } from "../../../redux/store/common/commonDuck";
import ContentHeaderComponent from "../../layout/ContentHeaderComponent";

import ReviewDetailModal from "./ReviewDetailModal";
import ReviewExcelUpload from "./ReviewExcelUpload";

const ReviewComponent = () => {
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);
  const isLoading = useSelector((state) => state.common.loading);
  const setIsLoading = (value) => dispatch(setLoading(value));

  const [dateType, setDateType] = useState("1week");
  const [searchOptions, setSearchOptions] = useState({
    startDate: moment().subtract(7, "days").startOf("day"),
    endDate: moment().endOf("day"),
    reviewStatus: "total",
    reviewGrade: 0,
    benefitPayment: "total",
    exposureStatus: "total",
    bestReview: "total",
    searchType: "product",
    // searchType: "order_id",
    searchText: "",
  });
  const [orderType, setOrderType] = useState("created_at");
  const [orderBy, setOrderBy] = useState("desc");
  const [totalSize, setTotalSize] = useState(0);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [offset, setOffset] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [reviewList, setReviewList] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [error, setError] = useState("");

  const [reviewModalShow, setReviewModalShow] = useState(false);

  const [reviewDetailModalShow, setReviewDetailModalShow] = useState(false);
  const [currentReviewId, setCurrentReviewId] = useState(0);

  const dateTypeItems = [
    { label: "오늘", value: "today" },
    { label: "1주일", value: "1week" },
    { label: "1개월", value: "1month" },
    { label: "3개월", value: "3month" },
    { label: "6개월", value: "6month" },
    { label: "1년", value: "1year" },
  ];
  const reviewStatusItems = [
    { label: "전체", value: "total" },
    { label: "포토리뷰", value: "photo" },
    { label: "텍스트리뷰", value: "text" },
  ];
  const reviewGradeItems = [
    { label: "전체", value: 0 },
    { label: "1점", value: 1 },
    { label: "2점", value: 2 },
    { label: "3점", value: 3 },
    { label: "4점", value: 4 },
    { label: "5점", value: 5 },
  ];
  const benefitPaymentItems = [
    { label: "전체", value: "total" },
    { label: "지급완료", value: "true" },
    { label: "미지급", value: "false" },
  ];
  const exposureStatusItems = [
    { label: "전체", value: "total" },
    { label: "정상", value: "true" },
    { label: "미노출", value: "false" },
  ];
  const bestReviewItems = [
    { label: "전체", value: "total" },
    { label: "베스트Y", value: "true" },
    { label: "베스트N", value: "false" },
  ];
  const searchTypeItems = [
    { searchType: "product", searchText: "상품명" },
    { searchType: "product_id", searchText: "상품번호" },
    { searchType: "order_id", searchText: "상품주문번호" },
    { searchType: "review_body", searchText: "내용" },
  ];
  const orderPair = {
    order_id: "상품주문번호순",
    review_score: "평점순",
    created_at: "리뷰등록일순",
    updated_at: "최종수정일순",
    review_private: "전시상태순",
    review_report: "신고여부순",
    review_point: "혜택지급순",
    is_best: "베스트리뷰순",
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys);
      setSelectedRows(selectedRows);
    },
  };
  const columns = [
    {
      title: "상품번호",
      // width: 120,
      dataIndex: "product_id",
      key: "product_id",
      fixed: "left",
      align: "center",
      ellipsis: true,
      // sorter: (a, b) => {},
      onCell: (record) => {
        return {
          onClick: () => {
            // history.push(`/nutrients/view/certified/${record.id}`)
          },
        };
      },
    },
    {
      title: "상품주문번호",
      // width: 120,
      dataIndex: "order_id",
      key: "order_id",
      align: "center",
      ellipsis: true,
      // sorter: (a, b) => {},
      onCell: (record) => {
        return {
          onClick: () => {
            // history.push(`/nutrients/view/certified/${record.id}`)
          },
        };
      },
    },
    {
      title: "상품명",
      width: 120,
      dataIndex: "product_name",
      key: "product_name",
      ellipsis: true,
      onCell: (record) => {
        return {
          onClick: () => {
            // history.push(`/nutrients/view/certified/${record.id}`)
          },
        };
      },
    },
    {
      title: "평점",
      // width: 120,
      dataIndex: "review_score",
      key: "review_score",
      ellipsis: true,
      align: "center",
      sorter: (a, b) => {},
      render: (value, record) => {
        let scoreList = [];
        for (let i = 0; i < value; i++) {
          scoreList.push(
            <img
              key={`star_${record.id}_${i + 1}`}
              className="review-score-img"
              src={`${process.env.REACT_APP_HOST}/assets/images/inquiry/selectGrade.png`}
            />,
          );
        }
        if (value !== 5) {
          for (let i = 0; i < 5 - value; i++) {
            scoreList.push(
              <img
                key={`star${i + 1}`}
                className="review-score-img"
                src={`${process.env.REACT_APP_HOST}/assets/images/inquiry/unSelectGrade.png`}
              />,
            );
          }
        }
        return (
          <>
            <Row align="middle" wrap={false}>
              {scoreList.map((score) => score)}
            </Row>
            <span className="review-score-text">{value}점</span>
          </>
        );
      },
    },
    {
      title: "포토",
      // width: 120,
      dataIndex: "review_img_quantity",
      key: "review_img_quantity",
      ellipsis: true,
      align: "center",
      onCell: (value, record) => {
        return {
          onClick: (e) => {
            e.stopPropagation();
            setCurrentReviewId(value.id);
            setReviewDetailModalShow(true);
          },
        };
      },
      render: (value, record) => {
        if (value !== 0) {
          return (
            <img
              className="review-main-img"
              style={{
                width: "120px",
                height: "120px",
                objectFit: "cover",
              }}
              src={`${process.env.REACT_APP_S3_HOST}/image/review/${
                record.product_id
              }/${record.created_by}_${record.id}_0.${
                record.review_title.split("-")[1]
              }`}
              alt={`review main img`}
            />
          );
        } else {
          return "없음";
        }
      },
    },
    {
      title: "리뷰내용",
      width: 180,
      dataIndex: "review_body",
      key: "review_body",
      // ellipsis: true,
      onCell: (value, record) => {
        return {
          onClick: (e) => {
            // history.push(`/nutrients/view/certified/${record.id}`)
            e.stopPropagation();
            setCurrentReviewId(value.id);
            setReviewDetailModalShow(true);
          },
        };
      },
      render: (value) => {
        return <span>{value}</span>;
      },
    },
    {
      title: "전시상태",
      // width: 120,
      dataIndex: "review_private",
      key: "review_private",
      ellipsis: true,
      align: "center",
      sorter: (a, b) => {},
      render: (value) => {
        if (value === 0) {
          return "정상";
        } else {
          return "미노출";
        }
      },
    },
    {
      title: "베스트여부",
      // width: 120,
      dataIndex: "is_best",
      key: "is_best",
      ellipsis: true,
      align: "center",
      sorter: (a, b) => {},
      render: (value) => {
        if (value) {
          return "Y";
        } else {
          return "N";
        }
      },
    },
    {
      title: "신고여부",
      // width: 120,
      dataIndex: "review_report",
      key: "review_report",
      ellipsis: true,
      align: "center",
      // sorter: (a, b) => {},
      render: (value, record) => {
        if (value) {
          return (
            <>
              <p>Y</p>
              <p>({moment(record.review_report_date).format("YYYY.MM.DD")})</p>
            </>
          );
        } else {
          return "N";
        }
      },
    },
    {
      title: "혜택지급",
      // width: 120,
      dataIndex: "review_point",
      key: "review_point",
      ellipsis: true,
      align: "center",
      render: (value) => {
        if (value !== null) {
          return (
            <>
              <p>Y</p>
              <p>({value}P)</p>
            </>
          );
        } else {
          return "N";
        }
      },
    },
    {
      title: "등록자",
      // width: 120,
      dataIndex: "created_by_name",
      key: "created_by_name",
      ellipsis: true,
      align: "left",
    },
    {
      title: "리뷰등록일",
      // width: 150,
      dataIndex: "created_at",
      key: "created_at",
      ellipsis: true,
      align: "center",
      sorter: (a, b) => {},
      render: (value) => {
        if (value) {
          return (
            <>
              <p>{moment(value).format("YYYY.MM.DD")}</p>
              <p>{moment(value).format("HH:mm:ss")}</p>
            </>
          );
        }
      },
    },
    {
      title: "최종수정일",
      // width: 180,
      dataIndex: "updated_at",
      key: "updated_at",
      ellipsis: true,
      align: "center",
      // sorter: (a, b) => {},
      render: (value) => {
        if (value) {
          return (
            <>
              <p>{moment(value).format("YYYY.MM.DD")}</p>
              <p>{moment(value).format("HH:mm:ss")}</p>
            </>
          );
        }
      },
    },
  ];

  useEffect(() => {
    getReadReviews("initial");
  }, []);

  useEffect(() => {
    getReadReviews();
  }, [offset, pageSize, orderType, orderBy]);

  const getReadReviews = async (type = "") => {
    setIsLoading(true);
    try {
      let param;
      if (type === "initial") {
        param = {
          offset: 0,
          pageSize: 10,
          startDate: moment()
            .subtract(7, "days")
            .startOf("day")
            .format("YYYYMMDDHHmm"),
          endDate: moment().endOf("day").format("YYYYMMDDHHmm"),
          reviewStatus: reviewStatusItems[0].value,
          reviewGrade: reviewGradeItems[0].value,
          benefitPayment: benefitPaymentItems[0].value,
          exposureStatus: exposureStatusItems[0].value,
          bestReview: bestReviewItems[0].value,
          searchType: searchTypeItems[0].searchType,
          searchText: "",
          orderType: "created_at",
          orderBy: "desc",
          userId: user.id === 724 ? 1 : user.id,
        };
      } else if (type === "search") {
        param = {
          offset: 0,
          pageSize: 10,
          ...searchOptions,
          startDate: searchOptions.startDate.format("YYYYMMDDHHmm"),
          endDate: searchOptions.endDate.format("YYYYMMDDHHmm"),
          orderType,
          orderBy,
          userId: user.id === 724 ? 1 : user.id,
        };
      } else {
        param = {
          offset,
          pageSize,
          ...searchOptions,
          startDate: searchOptions.startDate.format("YYYYMMDDHHmm"),
          endDate: searchOptions.endDate.format("YYYYMMDDHHmm"),
          orderType,
          orderBy,
          userId: user.id === 724 ? 1 : user.id,
        };
      }
      const res = await reviewApi.readReviewList(param);
      if (res.code === 200) {
        setReviewList(res.result.reviewList);
        setTotalSize(res.result.totalCtn);
      } else {
        alert(
          "리뷰 목록을 조회해오지 못하였습니다. 다시 시도해주시거나 관리자에게 문의해주시길 바랍니다.",
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("getReadReviews read error", error);
    }
  };

  /**
   * 표출/미표출여부 수정 버튼 click
   */
  const handleEditBtnClick = async () => {
    setIsLoading(true);
    try {
      let newEditReview = {
        editList: selectedRowKeys,
        editKey: "review_private",
        editor: user.user_id,
      };
      // if (btnStatus === 2) {
      //     newEditReview["editValue"] = 0
      // } else if (btnStatus === 1) {
      //     newEditReview["editValue"] = 1
      // }
      const res = await reviewApi.editReview(newEditReview);
      if (res.code === 200) {
        alert("해당 내용이 성공적으로 수정되었습니다.");
        getReadReviews();
        setSelectedRowKeys([]);
        setSelectedRows([]);
      } else if (res.code === 999) {
        alert(res.msg);
      } else {
        alert("정상적인 요청이 아닙니다.");
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("handleEditBtnClick edit error", error);
    }
  };

  /**
   * handle dateType change
   */
  const handleDateTypeChange = (e) => {
    const value = e.target.value;
    setDateType(value);
    switch (value) {
      case "today":
        setSearchOptions({
          ...searchOptions,
          startDate: moment().startOf("day"),
          endDate: moment().endOf("day"),
        });
        break;
      case "1week":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(7, "days").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(7, "days")
              .startOf("day"),
          });
        }
        break;
      case "1month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(1, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(1, "months")
              .startOf("day"),
          });
        }
        break;
      case "3month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(3, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(3, "months")
              .startOf("day"),
          });
        }
        break;
      case "6month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(6, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(6, "months")
              .startOf("day"),
          });
        }
        break;
      case "1year":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(1, "year").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(1, "year")
              .startOf("day"),
          });
        }
        break;
    }
  };

  /**
   * 검색
   */
  const handleSearch = () => {
    if (searchOptions.startDate === null || searchOptions.endDate === null) {
      alert("조회하려는 기간이 없습니다. 다시 설정해주시길 바랍니다.");
    } else {
      if (!searchOptions.startDate.isBefore(searchOptions.endDate)) {
        alert(
          "조회하려는 기간이 잘못 설정되어있습니다. 다시 시도해주시길 바랍니다.",
        );
      } else {
        setOffset(0);
        setPageSize(10);
        setCurrentPageNumber(1);
        getReadReviews("search");
      }
    }
  };

  /**
   * 초기화
   */
  const handleInitialBtnClick = () => {
    setDateType(dateTypeItems[1].value);
    setSearchOptions({
      startDate: moment().subtract(7, "days").startOf("day"),
      endDate: moment().endOf("day"),
      reviewStatus: reviewStatusItems[0].value,
      reviewGrade: reviewGradeItems[0].value,
      benefitPayment: benefitPaymentItems[0].value,
      exposureStatus: exposureStatusItems[0].value,
      bestReview: bestReviewItems[0].value,
      searchType: searchTypeItems[0].searchType,
      searchText: "",
    });
    setOffset(0);
    setPageSize(10);
    getReadReviews("initial");
  };

  /**
   * excel download
   */
  // const handleExcelDownloadClick = () => {
  // 	try {
  // 		let excelData;
  // 		// if (totalOrderList?.length !== 0) {
  // 		//     excelData = totalOrderList.map((row) => {
  // 		//         return {
  // 		//             order_id: row.order_id,
  // 		//             order_detail_id: row.order_detail_id,
  // 		//             created_at: moment(row.created_at).format("YYYY.MM.DD HH:mm"),
  // 		//             payment_created_at: moment(row.payment_created_at).format("YYYY.MM.DD HH:mm"),
  // 		//             product_id: row.product_id,
  // 		//             product_name: row.product_name,
  // 		//             order_detail_status: status.matchingOrderStatus[row.order_detail_status],
  // 		//             quantity: row.quantity,
  // 		//             delivery_company: status.matchingDeliveryCompany[row.delivery_company] ? status.matchingDeliveryCompany[row.delivery_company] : row.delivery_company,
  // 		//             tracking_number: row.tracking_number,
  // 		//             ship_date: row.ship_date ? moment(row.ship_date).format("YYYY.MM.DD") : row.ship_date,
  // 		//             created_by_name: row.created_by_name,
  // 		//             name: row.name
  // 		//         }
  // 		//     })
  // 		// } else {
  // 		//     alert("다운받으려는 데이터가 없습니다. 조회 후 다시 시도해주시길 바랍니다.")
  // 		//     throw "no data"
  // 		// }
  // 		// const wb = XLSX.utils.book_new()
  // 		// const ws = XLSX.utils.json_to_sheet(excelData)
  // 		// Object.keys(excelData[0]).forEach((key, idx) => {
  // 		//     const cellAdd = XLSX.utils.encode_cell({ c: idx, r: 0 })
  // 		//     ws[cellAdd].v = status.matchingKey[key]
  // 		// })
  // 		// XLSX.utils.book_append_sheet(wb, ws, '주문취소관리')
  // 		// XLSX.writeFile(wb, `${moment().format("YYYYMMDD")}_주문취소관리.xlsx`)
  // 	} catch (error) {
  // 		setIsLoading(false);
  // 		setError(error);
  // 		console.log("handleExcelDownloadClick edit error", error);
  // 	}
  // };

  const tableOnChange = (pagination, filters, sorter) => {
    if (sorter) {
      //sorting 이벤트가 이루어졌을때
      if (sorter.order) {
        if (sorter.order === "descend") {
          setOrderBy("desc");
        } else if (sorter.order === "ascend") {
          setOrderBy("asc");
        }
        setOrderType(sorter.field);
        //sorting 이벤트 데이터가 초기화 되었을 시 (order 값 초기화)
      } else {
        setOrderType("created_at");
        setOrderBy("desc");
      }
    }
  };

  /**
   * handleRowEvent
   */
  const handleRowEvent = (record) => {
    return {
      onClick: () => {
        let editRowKeys = [];
        let editRows = [];
        if (selectedRowKeys.includes(record.id)) {
          editRowKeys = selectedRowKeys.filter((key) => key !== record.id);
          editRows = selectedRows.filter((row) => row.id !== record.id);
        } else {
          editRowKeys = [...selectedRowKeys, record.id];
          editRows = [...selectedRows, record];
        }
        setSelectedRowKeys(editRowKeys);
        setSelectedRows(editRows);
      },
    };
  };

  /**
   * page 넘김
   */
  const handleChangePagination = (pageNumber, pageSize) => {
    const offset = (pageNumber - 1) * pageSize;
    setCurrentPageNumber(pageNumber);
    setOffset(offset);
    setPageSize(pageSize);
  };

  /**
   * 리뷰 목록 - 미노출
   * @returns {Promise<void>}
   */
  const handleReviewNoShow = async () => {
    if (window.confirm("미노출 처리하시겠습니까?")) {
      setIsLoading(true);
      const param = {
        user_id: user.id === 724 ? 1 : user.id,
        editList: selectedRowKeys,
        editKey: "review_private",
        editValue: 1,
      };
      const res = await reviewApi.editReview(param);
      if (res.code === 200) {
        alert("정상적으로 수정이 완료 되었습니다.");
        getReadReviews();
        setSelectedRowKeys([]);
        setSelectedRows([]);
      } else {
        alert(res?.msg);
      }
      setIsLoading(false);
    }
  };

  /**
   * 리뷰 목록 - 노출
   * @returns {Promise<void>}
   */
  const handleReviewShow = async () => {
    if (window.confirm("노출 처리하시겠습니까?")) {
      setIsLoading(true);
      const param = {
        user_id: user.id === 724 ? 1 : user.id,
        editList: selectedRowKeys,
        editKey: "review_private",
        editValue: 0,
      };
      const res = await reviewApi.editReview(param);
      if (res.code === 200) {
        alert("정상적으로 수정이 완료 되었습니다.");
        getReadReviews();
        setSelectedRowKeys([]);
        setSelectedRows([]);
      } else {
        alert(res?.msg);
      }
      setIsLoading(false);
    }
  };

  /**
   * 리뷰 베스트 선정/해제 버튼 클릭 함수
   * @returns {Promise<void>}
   */
  const handleReviewBest = async () => {
    const bestResult = selectedRows?.every((row) => row.is_best);
    Swal.fire({
      title: bestResult
        ? "선택된 베스트리뷰를 해제하시겠습니까?\n(상품페이지 리뷰 상단에서 노출되지 않게 됩니다.)"
        : "베스트리뷰 선정 시 사진이 첨부되었거나 꼼꼼하게 작성된 리뷰를 선정해주세요.\n(선정된 베스트리뷰는 상품페이지 리뷰 상단에 자동으로 노출됩니다.)",
      customClass: "custom-alert",
      confirmButtonColor: "#117ffa",
      confirmButtonText: "확인",
    }).then(async ({ isConfirmed }) => {
      // console.log("Swal result = ", isConfirmed);
      if (isConfirmed) {
        setIsLoading(true);
        const param = {
          user_id: user.id === 724 ? 1 : user.id,
          editList: selectedRowKeys,
          editKey: "is_best",
          is_best: !bestResult,
        };
        // console.log("param == ", param);
        const res = await reviewApi.editReview(param);
        if (res.code === 200) {
          alert("정상적으로 수정이 완료되었습니다.");
          getReadReviews();
          setSelectedRowKeys([]);
          setSelectedRows([]);
        } else if (res.code === 999) {
          setIsLoading(false);
          alert(res.msg);
        } else {
          setIsLoading(false);
          alert(
            "해당 내용을 수정하는데 실패했습니다. 관리자에게 문의하시길 바랍니다.",
          );
        }
      }
    });
  };

  /**
   * 베스트 선정/해제 버튼 disabled 상태값
   * @returns {boolean}
   */
  const disabledBestBtnStatus = () => {
    let result = true;
    if (selectedRows.length) {
      const firstValue = selectedRows[0]?.is_best;
      result = !selectedRows?.every((row) => row.is_best === firstValue);
    }
    return result;
  };

  return (
    <>
      <ContentHeaderComponent title="리뷰관리" />
      <div className="product-register-wrap">
        {/*리뷰관리 검색*/}
        <div className="product-search-box-wrap">
          <Form.Item
            className="center-label"
            label="조회기간"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row align={"middle"} style={{ gap: "5px" }}>
              <Radio.Group
                className={`options-list`}
                options={dateTypeItems}
                onChange={handleDateTypeChange}
                value={dateType}
                optionType="button"
              />
              <DatePicker
                className="order-search-date-wrap"
                format="YYYY/MM/DD"
                value={searchOptions.startDate}
                onChange={(value) => {
                  setDateType("");
                  setSearchOptions({ ...searchOptions, startDate: value });
                }}
              />
              ~
              <DatePicker
                className="order-search-date-wrap"
                format="YYYY/MM/DD"
                value={searchOptions.endDate}
                onChange={(value) => {
                  setDateType("");
                  setSearchOptions({ ...searchOptions, endDate: value });
                }}
              />
            </Row>
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Form.Item
            className="center-label"
            label="리뷰타입"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Radio.Group
              options={reviewStatusItems}
              onChange={(e) =>
                setSearchOptions({
                  ...searchOptions,
                  reviewStatus: e.target.value,
                })
              }
              value={searchOptions.reviewStatus}
            />
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Form.Item
            label="카테고리"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row align="middle" wrap={false}>
              <Col span={2}>
                <div className="review-search-category-content-label">
                  구매자평점
                </div>
              </Col>
              <Radio.Group
                options={reviewGradeItems}
                onChange={(e) =>
                  setSearchOptions({
                    ...searchOptions,
                    reviewGrade: e.target.value,
                  })
                }
                value={searchOptions.reviewGrade}
              />
            </Row>
            <Divider className="product-register-form-input-divider" />
            <Row align="middle" wrap={false}>
              <Col span={2}>
                <div className="review-search-category-content-label">
                  혜택지급
                </div>
              </Col>
              <Radio.Group
                options={benefitPaymentItems}
                onChange={(e) =>
                  setSearchOptions({
                    ...searchOptions,
                    benefitPayment: e.target.value,
                  })
                }
                value={searchOptions.benefitPayment}
              />
            </Row>
            <Divider className="product-register-form-input-divider" />
            <Row align="middle" wrap={false}>
              <Col span={2}>
                <div className="review-search-category-content-label">
                  전시상태
                </div>
              </Col>
              <Radio.Group
                options={exposureStatusItems}
                onChange={(e) =>
                  setSearchOptions({
                    ...searchOptions,
                    exposureStatus: e.target.value,
                  })
                }
                value={searchOptions.exposureStatus}
              />
            </Row>
            <Divider className="product-register-form-input-divider" />
            <Row align="middle" wrap={false}>
              <Col span={2}>
                <div className="review-search-category-content-label">
                  베스트리뷰
                </div>
              </Col>
              <Radio.Group
                options={bestReviewItems}
                onChange={(e) =>
                  setSearchOptions({
                    ...searchOptions,
                    bestReview: e.target.value,
                  })
                }
                value={searchOptions.bestReview}
              />
            </Row>
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Form.Item
            className="center-label"
            label="상세검색"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Select
              value={searchOptions.searchType}
              onChange={(value) =>
                setSearchOptions({ ...searchOptions, searchType: value })
              }
              style={{ width: 200, textAlign: "left" }}
            >
              {searchTypeItems.map((item, idx) => (
                <Option key={`search_type_${idx}`} value={item.searchType}>
                  {item.searchText}
                </Option>
              ))}
            </Select>
            <Input
              className="inquiry-search-input-wrap"
              placeholder="검색어를 입력하세요."
              name="searchText"
              value={searchOptions.searchText}
              onChange={(e) =>
                setSearchOptions({
                  ...searchOptions,
                  [e.target.name]: e.target.value,
                })
              }
              onPressEnter={handleSearch}
            />
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Row className="review-search-button-wrap" justify="center">
            <Button
              className="review-search-button search"
              onClick={handleSearch}
            >
              검색
            </Button>
            <Button
              className="review-search-button initial"
              onClick={handleInitialBtnClick}
            >
              초기화
            </Button>
          </Row>
        </div>

        {/*리뷰 목록*/}
        <Row
          className="product-register-border-box"
          justify={"space-between"}
          wrap={false}
          style={{ marginTop: 20 }}
        >
          <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
            <span className="product-register-box-title">
              리뷰 목록 (총{" "}
              <span
                className="product-register-box-subtitle"
                style={{ marginLeft: 0 }}
              >
                {totalSize}
              </span>
              개)
            </span>
            <span className="product-list-subtitle">
              {orderPair[orderType]}
            </span>

            <Row
              style={{
                marginLeft: "auto",
                gap: "0.5em",
              }}
            >
              <Button
                style={{
                  fontSize: "0.9em",
                }}
                danger={
                  selectedRows.length &&
                  selectedRows?.every((row) => row.is_best)
                }
                disabled={disabledBestBtnStatus()}
                onClick={handleReviewBest}
              >
                {selectedRows.length &&
                selectedRows?.every((row) => row.is_best)
                  ? "베스트 해제"
                  : "베스트 선정"}
              </Button>
              <Button
                style={{
                  fontSize: "0.9em",
                }}
                disabled={
                  !selectedRows.length ||
                  selectedRows?.filter((item) => !item.review_private)?.length
                }
                onClick={handleReviewShow}
              >
                노출
              </Button>
              <Button
                style={{
                  fontSize: "0.9em",
                }}
                disabled={
                  !selectedRows.length ||
                  selectedRows?.filter((item) => item.review_private)?.length
                }
                onClick={handleReviewNoShow}
              >
                미노출
              </Button>
              <Button
                style={{
                  fontSize: "0.9em",
                }}
                onClick={() => setReviewModalShow(true)}
              >
                <img
                  style={{ height: 14.2, width: 14.5, marginRight: 5 }}
                  src={`${process.env.REACT_APP_HOST}/assets/images/salesManage/microsoftexcel.png`}
                />
                리뷰 엑셀 업로드
              </Button>
            </Row>
          </div>
          {/*<Button className="order-excel-download-btn" icon={<img style={{height: 14.2, width: 14.5, marginRight: 5}} src={`${process.env.REACT_APP_HOST}/assets/images/salesManage/microsoftexcel.png`} />} onClick={handleExcelDownloadClick}>엑셀다운</Button>*/}
        </Row>
        <div
          className="product-register-border-box"
          wrap={false}
          style={{
            borderTop: 0,
            padding: "20px 25px 40px",
            height: "fit-content",
          }}
        >
          <Table
            className="review-table-wrap"
            rowSelection={rowSelection}
            columns={columns}
            dataSource={reviewList}
            loading={isLoading}
            tableLayout={"auto"}
            bordered
            size="middle"
            rowKey="id"
            rowClassName="coupon-table-row"
            scroll={{ x: "max-content" }}
            onChange={tableOnChange}
            onRow={handleRowEvent}
            pagination={false}
          />

          <div style={{ textAlign: "right" }}>
            <Pagination
              showQuickJumper
              showSizeChanger
              total={totalSize}
              pageSize={pageSize}
              onChange={handleChangePagination}
              style={{ marginTop: 20 }}
              current={currentPageNumber}
            />
          </div>
        </div>
      </div>

      {/* 엑셀 일괄 업로드 */}
      {reviewModalShow && (
        <Modal
          className="excel-delivery-modal"
          title="엑셀 일괄 업로드"
          visible={reviewModalShow}
          onCancel={() => setReviewModalShow(false)}
          footer={null}
        >
          <ReviewExcelUpload
            setReviewModalShow={setReviewModalShow}
            getReadReviews={getReadReviews}
          />
        </Modal>
      )}

      {/* 리뷰 상세보기 */}
      {reviewDetailModalShow && (
        <ReviewDetailModal
          reviewDetailModalShow={reviewDetailModalShow}
          setReviewDetailModalShow={setReviewDetailModalShow}
          currentReviewId={currentReviewId}
          searchOptions={searchOptions}
          orderType={orderType}
          orderBy={orderBy}
          getReadReviews={getReadReviews}
        />
      )}
    </>
  );
};

export default ReviewComponent;
